import { validAmount } from "../common-helpers";

const growthRate = {
	gfy: {
		"2": {
			"5" : "1.10",
			"10" : "1.22",
			"15" : "1.35",
			"20" : "1.49",
			"25" : "2.64",
			"30" : "2.81",
		},
		"3": {
			"5" : "1.16",
			"10" : "1.34",
			"15" : "1.56",
			"20" : "1.81",
			"25" : "2.09",
			"30" : "2.43",
		},
		"6": {
			"5" : "1.34",
			"10" : "1.79",
			"15" : "2.40",
			"20" : "3.21",
			"25" : "4.29",
			"30" : "5.74",
		},
		"8": {
			"5" : "1.47",
			"10" : "2.16",
			"15" : "3.17",
			"20" : "4.66",
			"25" : "6.85",
			"30" : "10.06",
		},
		"10": {
			"5" : "1.61",
			"10" : "2.59",
			"15" : "4.18",
			"20" : "6.73",
			"25" : "10.83",
			"30" : "17.45",
		},
	},
	gfr: {
		"35": {
			"20" : "19.5",
			"25" : "24.2",
			"30" : "28.8",
			"35" : "33.4",
		},
		"50": {
			"20" : "18.1",
			"25" : "22.1",
			"30" : "25.8",
			"35" : "29.4",
		},
		"65": {
			"20" : "16.7",
			"25" : "20",
			"30" : "23",
			"35" : "25",
		},
	},
	gfs: {
		"6": {
			"5" : ".01354",
			"10" : ".00541",
			"15" : ".00288",
			"20" : ".00172",
			"25" : ".00109",
			"30" : ".00072",
		},
		"8": {
			"5" : ".01301",
			"10" : ".00493",
			"15" : ".00248",
			"20" : ".00140",
			"25" : ".00083",
			"30" : ".00052",
		},
		"10": {
			"5" : ".01250",
			"10" : ".00449",
			"15" : ".00213",
			"20" : ".00113",
			"25" : ".00063",
			"30" : ".00036",
		}
	}
}

export	const yearsOptions = [
		{label: "5", value: "5"},
		{label: "10", value: "10"},
		{label: "15", value: "15"},
		{label: "20", value: "20"},
		{label: "25", value: "25"},
		{label: "30", value: "30"},
		{label: "35", value: "35"},
	];

export	const replacementOptions = [
		{label: "50%", value: "0.5"},
		{label: "55%", value: "0.55"},
		{label: "60%", value: "0.6"},
		{label: "65%", value: "0.65"},
		{label: "70%", value: "0.7"},
		{label: "75%", value: "0.75"},
		{label: "80%", value: "0.8"},
		{label: "85%", value: "0.85"},
		{label: "90%", value: "0.9"},
		{label: "95%", value: "0.95"},
		{label: "100%", value: "1"},
		{label: "105%", value: "1.05"},
		{label: "110%", value: "1.1"},
	];

export const getTargetAnnualIncome = (grossIncomeCombined: number, yearsToRetirement: string, incomeReplacement: string) => {
	const projectedAnnualIncomeBoth = Math.round(grossIncomeCombined * Number(growthRate.gfy["3"][yearsToRetirement]));
	return Math.round(projectedAnnualIncomeBoth * Number(incomeReplacement));
};

export const getAnnualSsiPension = (
	mrpIncome: { self: string, spouse: string, combined: number },
	cola: { self: string, spouse: string },
	mssIncomeCombined: number,
	yearsToRetirement: string
) => {
	const annual_pension_both = (Number(validAmount(mrpIncome.self))*Number(cola.self))+(Number(validAmount(mrpIncome.spouse))*Number(cola.spouse));
	return Math.round((mssIncomeCombined*12 + annual_pension_both) * Number(growthRate.gfy["3"][yearsToRetirement]));
};

export const getProjectedSavings = (retirementAccountsCombined: number, investmentsReturn: string, yearsToRetirement: string) => {
	return Math.round(retirementAccountsCombined * Number(growthRate.gfy[investmentsReturn][yearsToRetirement]));
};

export const getNestEggGoal = (target_annual_retirement_income: number, annual_ssi_pension_all_gf: number, retirementStocks: string, yearsInRetirement: string ) => {
	return Math.round((target_annual_retirement_income - annual_ssi_pension_all_gf) * Number(growthRate.gfr[retirementStocks][yearsInRetirement]));
};

export const getRequiredMonthlyAmount = (
	homeValue: string,
	yearsToRetirement: string,
	remainingMortgage: string,
	cashTowardsNewHome: string,
	nestegg_goal: number,
	projected_savings_balance: number,
	additionalAssets: string,
	investmentsReturn: string
) => {
	const estimated_home_value_at_retirement = Math.round(Number(validAmount(homeValue)) * growthRate.gfy["2"][yearsToRetirement]);// 300 000 * 2.64 = 792 000
	const homes_contribution_to_nestegg = estimated_home_value_at_retirement - (Number(validAmount(remainingMortgage)) + Number(validAmount(cashTowardsNewHome)));// 792 000 - (0 + 300 000) = 492 000
	let nestegg_shortfall = nestegg_goal - (projected_savings_balance + homes_contribution_to_nestegg + Number(validAmount(additionalAssets)));//4083108 - (1370000 + 492 000 + 5 000) = 2 216 108
	if (nestegg_shortfall <= 0) nestegg_shortfall = 0;
	return Math.round(nestegg_shortfall * Number(growthRate.gfs[investmentsReturn][yearsToRetirement]));//2 216 108 * 0.00083 = 1839
};
